import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const WrapperDiv = styled.div`
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    position: relative;
    height: 100%;
    flex-grow: 1;
    padding-right: 35px;
`;

export const ExitPreviewButtonDiv = styled.div`
    height: 30px;
    padding: 10px 0px;
    position: relative;
    margin-right: 5px;
`;

export const PreviewButtonDiv = styled.div`
    width: 30px;
    height: 30px;
    padding: 10px 5px;
    position: relative;
`;

export const ButtonDiv = styled.div`
    text-align: center;
    font-size: 20px;
    width: 30px;
    height: 30px;
    padding: 11px 5px;
    margin-right: 16px;
    color: #535454;
`;

export const TipsButtonDiv = styled.div`
    width: 30px;
    height: 30px;
    padding: 10px 5px;
`;

export const TooltipText = styled.span`
    display: block;
    max-width: 124px;
    padding: 10px 5px;
    color: #1E1E1E;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
`;

export const Background = styled.div`
    align-items: center;
    background-color: rgba(0,0,0,0.8);
    bottom: 0px;
    display: flex;
    justify-content: center;
    left: 0px;
    position: fixed;
    right: 0px;
    top: 0px;
    z-index: 10;
`;

export const ModalBackground = styled.div`
    background-color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 40px;
    position: absolute;
    width: 442px;
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    -moz-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    /* stylelint-enable property-no-vendor-prefix */
    box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
`;

export const HeaderText = styled.h3`
    font-size: 20px;
    margin: 0;
`;

export const TextWrapper = styled.div`
    font-size: 15px;
    margin: 28px 0 20px 0;
`;

export const ReasonsList = styled.ul`
    margin: 8px 0;
`;

export const UpgradeBox = styled.div`
    padding: 8px;
    background-color: ${({ theme }) => theme.colors.pastelSecondary100};
    border: ${({ theme }) => `1px solid ${theme.colors.primary300}`};
    display: flex;
    margin-top: 16px;
    font-size: 13px;
    line-height: 18px;
    a:visited {
        color: #0000EE;
    }
`;

export const FAIcon = styled(FontAwesomeIcon)`
    color: ${({ theme }) => theme.colors.primary300};
    font-size: 16px;
    margin: 4px 12px;
`;

export const CheckboxWrapper = styled.div`
    cursor: pointer;
    display: flex;
    margin-bottom: 28px;
`;

export const CheckboxText = styled.div`
    color: ${({ theme }) => theme.colors.neutral700};
    font-size: 15px;
    margin-left: 8px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const DropDown = styled.div`
    background: rgb(255, 255, 255);
    border-radius: 0px;
    border: 1px solid rgb(204, 204, 204);
    box-shadow: 0px 0px 4px 0px rgba(28, 28, 28, 0.2);
    width: 148px;
    position: relative;
    z-index: 4;
    text-align: left;
    right: 70px;
    top: -12px;
    font-size: 16px;
    cursor: pointer;
`;

export const DropDownItem = styled.div`
    color: rgb(28, 28, 28);
    font-size: 13px;
    font-weight: normal;
    height: 20px;
    letter-spacing: 0px;
    line-height: 20px;
    display: flex;
    text-align: left;
    padding: 9px 7px 7px 8px;
    border-top: ${({ hasBorder }) => (hasBorder ? '1px solid rgb(217, 218, 219)' : 'none')}
`;
